import React, { memo } from "react";
import {
  View,
  Modal,
  TouchableOpacity,
  StyleSheet,
  Pressable,
} from "react-native";
import color from "@constants/color";
import { width } from "@constants/metrics";
import Text from "@components/CustomText";
import Cross from "@assets/svg/Cross";

interface Props {
  onPress?: (phoneNumber: string) => void;
  visible?: boolean;
  onPressCancel?: () => void;
  title?: string;
  text?: string;
  phoneNumbers: string[];
  maskedPhoneNumbers?: string[];
}

const OtpNumberModal = (props: Props) => {
  const {
    onPress = () => {},
    visible = true,
    onPressCancel = () => {},
    title = "",
    text = "",
    phoneNumbers = [],
    maskedPhoneNumbers = [],
  } = props;

  const displayPhoneNumbers =
    maskedPhoneNumbers && maskedPhoneNumbers.length
      ? maskedPhoneNumbers
      : phoneNumbers;

  return (
    <Modal
      statusBarTranslucent
      navigationBarTranslucent
      visible={visible}
      transparent={true}
    >
      <TouchableOpacity style={styles.modalContainer} onPress={onPressCancel}>
        <View
          style={styles.modalContent}
          onStartShouldSetResponder={() => true}
        >
          <Text variant="subtitle_20" style={styles.headingText}>
            {title}
          </Text>
          <View style={styles.buttonContainer}>
            {displayPhoneNumbers.map((number, index) => (
              <TouchableOpacity
                style={[styles.button]}
                onPress={() => onPress(phoneNumbers[index])}
                key={index}
              >
                <Text variant="body_text_3" style={styles.whiteButtonText}>
                  {`${number}`}
                </Text>
              </TouchableOpacity>
            ))}
          </View>
          <Pressable style={[styles.closeButton]} onPress={onPressCancel}>
            <Cross width={12} height={12} />
          </Pressable>
        </View>
      </TouchableOpacity>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalContainer: {
    backgroundColor: color.modalBackground,
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  modalContent: {
    width: width - 128,
    backgroundColor: color.white,
    borderRadius: 16,
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 18,
    paddingVertical: 20,
    marginBottom: 20,
  },
  headingText: {
    color: color.Gray20,
    paddingVertical: 8,
  },
  subHeadingText: {
    color: color.mediumBlacklightBlack,
    textAlign: "center",
  },
  buttonContainer: {
    // marginTop: 10,
    // flexDirection: "row",
    // justifyContent: "space-between",
  },
  button: {
    marginTop: 12,
    // marginHorizontal: 12,
    borderWidth: 0.5,
    borderRadius: 20,
    paddingVertical: 8,
    paddingHorizontal: 28,
    // flex: 1,
    alignItems: "center",
  },
  primaryButton: {
    borderColor: color.plain_green,
    backgroundColor: color.plain_green,
  },
  whiteButton: {
    borderColor: color.mediumBlacklightBlack,
    backgroundColor: color.white,
  },
  buttonText: {
    fontSize: 18,
    fontWeight: "500",
    lineHeight: 22,
  },
  primaryButtonText: {
    color: color.mediumBlacklightBlack,
  },
  whiteButtonText: {
    color: color.black,
  },
  closeButton: {
    position: "absolute",
    top: 12,
    right: 12,
    zIndex: 1,
  },
});

export default memo(OtpNumberModal);
